import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SettingsService } from '@delon/theme';
import { NzMessageService } from 'ng-zorro-antd/message';

export const sampleOrTrialAgentBlockGuard: CanActivateFn = () => {
  const settings = inject(SettingsService);
  const router = inject(Router);
  const msg = inject(NzMessageService);

  const company = settings.user['company'];
  const isSampleOrTrial = !!company?.isSample || !!company?.isFreeTrial;

  if (!isSampleOrTrial) {
    return true;
  }

  msg.warning(
    'Sales Agent and Customer Service Agent are not available for sample or free trial companies.'
  );
  return router.createUrlTree(['/dashboard']);
};
